/**
 * kanban-demo-fixtures.ts
 *
 * Isolated demo fixture data for demo and development-fixtures modes.
 * Statically tree-shaken from production builds via `import.meta.env.VITE_DATA_MODE`.
 */

import type { AppPlannerTask } from '../shell/kanban-task-store.js';

export function getDemoKanbanTasks(): AppPlannerTask[] {
  return [
    {
      id: 'task-88',
      title: 'Task #88: WebRTC DataChannel & Peer Signaling',
      description: 'Direct peer-to-peer data streaming for audio/video & whiteboard diffs without relay server overhead.',
      status: 'in_progress',
      taskType: 'project',
      contexts: ['@webrtc', '@p2p', '@bob'],
      estimateDays: 3,
      progressPercentage: 85,
      fractionalIndex: 'm00000',
      createdAt: Date.now() - 86400000 * 2,
      updatedAt: Date.now(),
      assignee: '@bob',
      _originKind: 'demo-fixture',
    },
    {
      id: 'task-92',
      title: 'Task #92: Setup Staging Database Permission Access',
      description: 'Configure staging Postgres DB and devops-sec role permissions for integration tests.',
      status: 'in_progress',
      taskType: 'task',
      contexts: ['@devops', '@database', '@bob'],
      estimateDays: 2,
      progressPercentage: 50,
      fractionalIndex: 'm10000',
      createdAt: Date.now() - 86400000,
      updatedAt: Date.now(),
      assignee: '@bob',
      blockers: ['Bob & Carol cannot access staging database permissions'],
      _originKind: 'demo-fixture',
    },
    {
      id: 'task-104',
      title: 'Task #104: Production Deployment Pipeline Release',
      description: 'Deploy release candidate to staging and production clusters.',
      status: 'backlog',
      taskType: 'goal',
      contexts: ['@release', '@alice'],
      estimateDays: 5,
      progressPercentage: 10,
      fractionalIndex: 'm20000',
      createdAt: Date.now() - 86400000 * 3,
      updatedAt: Date.now(),
      assignee: '@alice',
      blockers: ['Blocked by Task #92 staging database access resolution'],
      _originKind: 'demo-fixture',
    },
    {
      id: 'task-110',
      title: 'Task #110: Audit Local AI Inference Security & Ephemeral Ports',
      description: 'Verify zero Python execution and loopback bearer tokens',
      status: 'review',
      taskType: 'task',
      contexts: ['@local-ai', '@carol'],
      estimateDays: 1,
      progressPercentage: 90,
      fractionalIndex: 'm30000',
      createdAt: Date.now() - 43200000,
      updatedAt: Date.now(),
      assignee: '@carol',
      _originKind: 'demo-fixture',
    },
  ];
}
